import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  useTheme,
  useMediaQuery,
  Pagination,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { tokens } from "../components/Theme";

import waterImg from "./event_image/water.jpg";
import fetillzingImg from "./event_image/fertillzing.jpg";
import durianImg from "./event_image/durian.jpg";

const initialPayload = [
  {
    appOperId: "EVT20250414101251",
    date: "2025-04-14 10:12:51",
    description: "รดน้ำต้นไม้",
    image: waterImg,
  },
  {
    appOperId: "EVT20250513091548",
    date: "2025-05-13 09:15:48",
    description: "ให้ปุ๋ย",
    image: fetillzingImg,
  },
  {
    appOperId: "EVT20250605124835",
    date: "2025-06-05 12:48:35",
    description: "รดน้ำต้นไม้",
    image: durianImg,
  },
];

function EventImages() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [role] = useState("user");
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;

  useEffect(() => {
    setData(initialPayload);
  }, []);

  const handleChange = (index, key, value) => {
    const updated = [...data];
    updated[index][key] = value;
    setData(updated);
  };

  const handleAdd = () => {
    const newItem = {
      appOperId: "",
      date: "",
      description: "",
      image: null,
    };
    setData((prev) => [...prev, newItem]);
  };

  const handleDelete = (index) => {
    setData(data.filter((_, i) => i !== index));
  };

  const handleSave = () => {
    console.log("Event Payload:", data);
  };

  const paginatedData = data.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Box p={2}>
      <Typography variant="h6" mb={2}>
        กิจกรรมล่าสุดในสวน
      </Typography>

      {isMobile ? (
        paginatedData.map((row, index) => {
          const realIndex = (page - 1) * rowsPerPage + index;
          return (
            <Accordion key={realIndex}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>
                  {row.description || "ไม่มีคำอธิบายกิจกรรม"}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                {row.image && (
                  <Box display="flex" justifyContent="center" mb={1}>
                    <img
                      src={row.image}
                      alt="event"
                      style={{
                        width: "80%",
                        maxHeight: 200,
                        objectFit: "cover",
                      }}
                    />
                  </Box>
                )}
                {["appOperId", "date", "description"].map((key) => (
                  <TextField
                    key={key}
                    label={key}
                    fullWidth
                    margin="dense"
                    type={key === "date" ? "datetime-local" : "text"}
                    size="small"
                    value={row[key] || ""}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{ readOnly: role !== "admin" }}
                    onChange={(e) =>
                      handleChange(realIndex, key, e.target.value)
                    }
                  />
                ))}
                {role === "admin" && (
                  <Button
                    variant="outlined"
                    color="error"
                    fullWidth
                    sx={{ mt: 1 }}
                    onClick={() => handleDelete(realIndex)}
                  >
                    ลบรายการนี้
                  </Button>
                )}
              </AccordionDetails>
            </Accordion>
          );
        })
      ) : (
        <TableContainer component={Paper} sx={{ mb: 2 }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>รูป</TableCell>
                <TableCell>รหัส</TableCell>
                <TableCell>วันที่</TableCell>
                <TableCell>กิจกรรม</TableCell>
                {role === "admin" && <TableCell>ลบ</TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((row, index) => {
                const realIndex = (page - 1) * rowsPerPage + index;
                return (
                  <TableRow key={realIndex}>
                    <TableCell>{realIndex + 1}</TableCell>
                    <TableCell>
                      {row.image ? (
                        <img
                          src={row.image}
                          alt="event"
                          style={{
                            width: 100,
                            height: 100,
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        "ไม่มีรูป"
                      )}
                    </TableCell>
                    {["appOperId", "date", "description"].map((key) => (
                      <TableCell key={key}>
                        <TextField
                          variant="standard"
                          InputProps={{
                            disableUnderline: true,
                            readOnly: role !== "admin",
                            sx: {
                              minWidth: key === "appOperId" ? "160px" : "120px",
                              input: {
                                color: "#000",
                                WebkitTextFillColor: "#000",
                              },
                            },
                          }}
                          size="small"
                          type={key === "date" ? "datetime-local" : "text"}
                          value={row[key] || ""}
                          onChange={(e) =>
                            handleChange(realIndex, key, e.target.value)
                          }
                        />
                      </TableCell>
                    ))}
                    {role === "admin" && (
                      <TableCell>
                        <IconButton
                          color="error"
                          onClick={() => handleDelete(realIndex)}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Pagination
        sx={{ mt: "10px", marginX: isMobile ? 12 : 0 }}
        count={Math.ceil(data.length / rowsPerPage)}
        page={page}
        onChange={(e, value) => setPage(value)}
        color="primary"
      />

      {role === "admin" && (
        <Box mt={2} display="flex" justifyContent="space-between">
          <Button
            variant="contained"
            color="success"
            startIcon={<AddIcon />}
            onClick={handleAdd}
          >
            เพิ่มกิจกรรม
          </Button>
          <Button variant="contained" color="primary" onClick={handleSave}>
            บันทึก
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default EventImages;
